(function (angular) {
    "use strict";

    angular
        .module('harriMainApp')
        .controller("LMSContactUsModalController", LMSContactUsModal);

    LMSContactUsModal.$inject = ['$scope', 'modalData', 'onSave', 'onClose'];

    function LMSContactUsModal($scope, modalData, onSave, onClose) {
        var self = this;

        self.LMSContactUsForm = new LMSContactUsForm($scope, modalData, onSave, onClose);
        self.LMSContactUsForm.onViewLoaded();
        self.isSending = false;
        self.requestSent = false;
        self.modalData = modalData;

        this.submitFollowUp = function () {
            self.isSending = true;

            self.LMSContactUsForm.sendFollowUpRequest()
                .then(function (res) {
                    self.isSending = false;
                    self.requestSent = true;
                    $scope.$digest();
                }, function (error) {
                    self.isSending = false;

                    if (error.code === 'send_error') {
                        self.hideModal();
                        hAlert(
                            $filter("translate")("Something went wrong"),
                            $filter("translate")("Please try again later")
                        );
                    }
                    $scope.$digest();
                });
        };

        self.hideModal = function () {
            onClose();
            if (self.requestSent && (modalData.isRegistrationFlow || modalData.isUserExistFlow)) {
                onSave();
            }
            $scope.$hide();
        }
    }

})(angular);
